module.exports = __webpack_public_path__ + "img/role3.e601fa6d.gif";